import { useMsal } from "@azure/msal-react";

export type UserRoles = {
  isAdmin: boolean;
  isCreator: boolean;
  isContractNameEditor: boolean;
  isReader: boolean;
  roles: string[];
  highestRole: "EM-Admin" | "EM-Creator" | "EM-ContractNameEditor" | "EM-Reader";
  oid: string;
};

/**
 * Gibt ein Objekt mit Rollen-Flags, der vollständigen Rollenliste und der höchsten Rolle zurück.
 * Ein Benutzer ist automatisch Reader, wenn er weder Admin noch Creator ist.
 */
const useGetUserRoleFlags = (): UserRoles => {
  const { accounts } = useMsal();
  const account = accounts[0];

  const roles = account?.idTokenClaims?.roles as string[] | undefined;
  const roleList = roles ?? [];

  const isAdmin = roleList.includes("EM_F_Admin");
  const isCreator = roleList.includes("EM_F_Creator");
  const isContractNameEditor = roleList.includes("EM_F_EventContractNameEdit");
  const isReader = roleList.includes("EM_F_Reader") || (!isAdmin && !isCreator && !isContractNameEditor);

  let highestRole: UserRoles["highestRole"] = "EM-Reader";
  if (isAdmin) highestRole = "EM-Admin";
  else if (isCreator) highestRole = "EM-Creator";

  const oid = account.idTokenClaims?.oid ?? "";

  return {
    isAdmin,
    isCreator,
    isContractNameEditor,
    isReader,
    roles: roleList,
    highestRole,
    oid,
  };
};

export default useGetUserRoleFlags;